import { makeDefectListCache } from "./storage/cache";
import { CancelablePromise as Promise } from "./cancelablePromise";
import Api from "../services/api";
import { IDefect, TDefectAssetType } from "../model/Defect";
import { DriveStore } from "../store/reducers";
import { extend } from "./vanilla";

const cloneDefectLists = (defectLists: IDefect[]) => {
    let newDefectList: IDefect[] = [];
    (defectLists || []).forEach(defectList => {
        newDefectList.push(extend(true, {}, defectList));
    });
    return newDefectList;
};

export function getDefectListsForAssetType(api: Api, store: DriveStore, assetType: TDefectAssetType): Promise<IDefect[]> {
    let currentUser = api.getUser();
    const defectListCache = makeDefectListCache(store);
    let currentUserId = currentUser ? currentUser.id : undefined;
    let defectListsByAsset: {[assetId: string]: IDefect[]} = {};
    if (assetType === "Device") {
        defectListsByAsset = extend(true, {}, store.getState().deviceDefectLists[currentUserId || ""] || {}) as {[assetId: string]: IDefect[]};
    } else {
        defectListsByAsset = extend(true, {}, store.getState().trailerDefectLists[currentUserId || ""] || {}) as {[assetId: string]: IDefect[]};
    }
    let defectIdHash = {};
    let allDefectLists = ([] as IDefect[]).concat.apply([], (Object.keys(defectListsByAsset) || []).map(assetKey => defectListsByAsset[assetKey])) || [];
    allDefectLists = allDefectLists.filter(item => defectIdHash.hasOwnProperty(item.id) ? false : (defectIdHash[item.id] = true));
    return (defectListCache.getOrFetch(api, allDefectLists, currentUserId) as Promise<IDefect[]>).then(defectLists => ([] as IDefect[]).concat.apply([], defectLists)).then(cloneDefectLists);
}

export function getDefectListsForAsset(api: Api, store: DriveStore, entity: IIdEntity, assetType: TDefectAssetType): Promise<IDefect[]> {
    let currentUser = api.getUser();
    const defectListCache = makeDefectListCache(store);
    let currentUserId = currentUser ? currentUser.id : undefined;
    let defectListsByAsset: {[assetId: string]: IDefect[]} = {};
    if (assetType === "Device") {
        defectListsByAsset = extend(true, {}, store.getState().deviceDefectLists[currentUserId || ""] || {}) as {[assetId: string]: IDefect[]};
    } else {
        defectListsByAsset = extend(true, {}, store.getState().trailerDefectLists[currentUserId || ""] || {}) as {[assetId: string]: IDefect[]};
    }
    return (defectListCache.getOrFetch(api, defectListsByAsset[entity.id] || [], currentUserId) as Promise<IDefect[]>)
        .then(defectLists => ([] as IDefect[]).concat.apply([], defectLists)).then(cloneDefectLists);
}

export function populateDefectList(api: Api,  store: DriveStore, defectList: IIdEntity | null): Promise<IDefect | null> {
    let currentUser = api.getUser();
    const defectListCache = makeDefectListCache(store);
    if (!defectList || !defectList.id) {
        return Promise.resolve(null);
    }
    return defectListCache.getOrFetch(api, {id: defectList.id}, currentUser ? currentUser.id : undefined).then(dl => dl && dl[0] && dl[0][0] ? extend(true, {}, dl[0][0]) : null);
}